import DatePick_MI from 'components/DatePicker_MI'
import React from 'react'
import "./DateField.css";

const DateField = ({ label, infoKey = "", dateSubmit, setDateSubmit, storeValue, nameValue, set30Days = false, noMinMax = false }) => {
  return (
    <div className='row my-3 d-flex justify-content-start'>
      <div className='col-12 col-sm-6 col-md-6'>
        <p className='text-primary fw-bold field'>
          {label}
        </p>
      </div>
      <div className='col-12 col-sm-5 col-md-6 dateField'>
        <DatePick_MI
          infoKey={infoKey}
          dateSubmit={dateSubmit}
          setDateSubmit={setDateSubmit}
          storeValue={storeValue}
          nameValue={nameValue}
          displayCalendar={"bottom-start"}
          noMinMax={noMinMax}
          set30Days={set30Days}
        />
      </div>
    </div>
  )
}

export default DateField
